(function () {
  'use strict';

  if (window.__ttgPromoMessageFixLoaded) return;
  window.__ttgPromoMessageFixLoaded = true;

  var COPY = {
    de: {
      top: 'Aktion: Kauf 4, Zahl nur 3',
      promoHtml: '🎉 <strong>4 auswählen, nur 3 bezahlen.</strong> Der günstigste Artikel ist gratis.',
      cart: '🎉 4 auswählen, nur 3 bezahlen. Der günstigste Artikel ist gratis.',
      klarna: '✔ Jetzt kaufen, später mit Klarna bezahlen',
      paypal: '✔ Sicher mit PayPal oder Kreditkarte bezahlen'
    },
    en: {
      top: 'Special Offer: Choose 4, pay for 3',
      promoHtml: '🎉 <strong>Special Offer: Choose 4, pay for 3.</strong> The lowest-priced item is free.',
      cart: '🎉 Special Offer: Choose 4, pay for 3. The lowest-priced item is free.',
      klarna: '✔ Buy now, pay later with Klarna',
      paypal: '✔ Pay securely via PayPal or Credit Card'
    }
  };

  var scheduled = false;

  function language() {
    var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    return lang.indexOf('de') === 0 ? 'de' : 'en';
  }

  function copy() {
    return COPY[language()];
  }

  function normalized(value) {
    return (value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function isCampaignText(value) {
    var text = normalized(value);
    if (!text || text.length > 320) return false;

    return text.indexOf('4 auswählen, nur 3 bezahlen') !== -1 ||
      text.indexOf('special offer: 4 zahlen, 3 erhalten') !== -1 ||
      text.indexOf('special offer: pay 3, get 4') !== -1 ||
      text.indexOf('special offer: choose 4, pay for 3') !== -1 ||
      text.indexOf('choose 4, pay for 3') !== -1 ||
      text.indexOf('add 4 items to your cart') !== -1 ||
      text.indexOf('lege 4 artikel in den warenkorb') !== -1;
  }

  function normalizeTopBar() {
    var current = copy();
    var slides = document.querySelectorAll('.section--utility-bar .utility-announcement__slides[data-slide-id="2"] .utility-announcement__text');

    if (slides.length) {
      slides.forEach(function (element) {
        if (element.textContent.trim() !== current.top) element.textContent = current.top;
      });
      return;
    }

    document.querySelectorAll('.section--utility-bar .utility-announcement__text').forEach(function (element) {
      var text = normalized(element.textContent);
      var isKnownSecondMessage = text.indexOf('travel now, pay later with klarna') !== -1 ||
        (text.indexOf('sommerrabatt') !== -1 && text.indexOf('kauf 4') !== -1) ||
        (text.indexOf('aktion') !== -1 && text.indexOf('kauf 4') !== -1) ||
        text.indexOf('special offer: choose 4, pay for 3') !== -1;

      if (isKnownSecondMessage && element.textContent.trim() !== current.top) {
        element.textContent = current.top;
      }
    });
  }

  function deepestPromoContainers(root) {
    var matches = [];
    if (!root || !root.querySelectorAll) return matches;

    root.querySelectorAll('div, aside, p').forEach(function (element) {
      if (element.closest('.ttg-payments')) return;
      if (!isCampaignText(element.textContent)) return;

      var childMatch = Array.prototype.some.call(element.children || [], function (child) {
        return (child.tagName === 'DIV' || child.tagName === 'ASIDE' || child.tagName === 'P') && isCampaignText(child.textContent);
      });

      if (!childMatch) matches.push(element);
    });

    return matches;
  }

  function normalizeProductPromo() {
    var current = copy();
    var roots = document.querySelectorAll('.section--product-single, product-single');

    roots.forEach(function (root) {
      deepestPromoContainers(root).forEach(function (element) {
        if (normalized(element.innerHTML) !== normalized(current.promoHtml)) {
          element.innerHTML = current.promoHtml;
        }
      });
    });
  }

  function normalizePayments() {
    var current = copy();
    var desired = '<div>' + current.klarna + '</div><div>' + current.paypal + '</div>';

    document.querySelectorAll('.ttg-payments').forEach(function (element) {
      if (normalized(element.innerHTML) !== normalized(desired)) {
        element.innerHTML = desired;
      }
    });
  }

  function normalizeCartOffer() {
    var current = copy();
    document.querySelectorAll('.ttg-cart-offer').forEach(function (element) {
      if (element.textContent.trim() !== current.cart) element.textContent = current.cart;
    });
  }

  function applyAll() {
    scheduled = false;
    normalizeTopBar();
    normalizeProductPromo();
    normalizePayments();
    normalizeCartOffer();
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(applyAll);
  }

  function init() {
    applyAll();

    if (window.MutationObserver && document.body) {
      var observer = new MutationObserver(schedule);
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('cart:updated', schedule);
  document.addEventListener('cart:refresh', schedule);
})();
